module.exports = __webpack_public_path__ + "static/media/amj.f25d8f99.jpg";